import React from "react";
import { Link } from "react-router-dom";
import { Star, Zap, Fuel, GitCompareArrows } from "lucide-react";
import { formatPriceRange, resolveAsset } from "@/lib/api";

const BikeCard = ({ bike, onCompare, inCompare }) => {
    if (!bike) return null;
    const isElectric = bike.fuel_type === "Electric";
    const upcoming = Boolean(bike.is_upcoming);

    return (
        <div className="bike-card relative flex flex-col" data-testid={`bike-card-${bike.id}`}>
            <Link to={`/bikes/${bike.id}`} className="block">
                <div className="relative aspect-[4/3] bg-[#f3f4f6] overflow-hidden">
                    <img src={resolveAsset(bike.image)} alt={bike.name} className={`w-full h-full object-cover hover:scale-105 transition-transform duration-500 ${upcoming ? "opacity-90" : ""}`} loading="lazy" />
                    <span className="absolute top-3 right-3 chip chip-brand" data-testid={`bike-brand-${bike.id}`}>{bike.brand}</span>
                    {upcoming && (
                        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/70 to-transparent px-3 py-3">
                            <span className="chip chip-red bg-[#ED1C24] text-white px-3 py-1 text-xs font-bold">Coming soon — register interest</span>
                        </div>
                    )}
                </div>
            </Link>

            <div className="p-4 flex flex-col gap-3 flex-1">
                <Link to={`/bikes/${bike.id}`} className="block">
                    <p className="text-xs text-[#7a7a84] uppercase tracking-wider">{bike.subcategory}</p>
                    <h3 className="font-display font-bold text-base text-[#0f0f12] leading-tight mt-0.5 line-clamp-2">{bike.name}</h3>
                </Link>

                <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-[#4a4a52]">
                    <span className="flex items-center gap-1"><Star size={12} className="fill-[#ED1C24] text-[#ED1C24]" /> {bike.rating?.toFixed(1)}</span>
                    <span>•</span>
                    <span className="flex items-center gap-1">
                        {isElectric ? <Zap size={12} /> : <Fuel size={12} />}
                        {isElectric ? "Electric" : `${bike.engine_cc}cc`}
                    </span>
                    <span>•</span>
                    <span>{isElectric ? `${bike.range_km} km` : `${bike.mileage} kmpl`}</span>
                </div>

                <div className="flex items-end justify-between mt-auto">
                    <div>
                        <p className="text-xs text-[#7a7a84]">{upcoming ? "Expected ex-showroom" : "Ex-showroom"}</p>
                        <p className="font-display font-bold text-lg text-[#0f0f12]" data-testid={`bike-price-${bike.id}`}>
                            {upcoming ? "Enquire for price" : formatPriceRange(bike.price_min, bike.price_max)}
                        </p>
                    </div>
                    <button onClick={(e) => { e.preventDefault(); onCompare?.(bike); }}
                        className={`min-w-[44px] min-h-[44px] w-11 h-11 rounded-full border flex items-center justify-center transition-colors shrink-0 ${inCompare ? "border-[#ED1C24] bg-[#ED1C24] text-white" : "border-[#e5e7eb] hover:border-[#ED1C24] hover:text-[#ED1C24]"}`}
                        data-testid={`bike-compare-${bike.id}`}
                        aria-label={inCompare ? "In compare shortlist" : "Add to compare"}>
                        <GitCompareArrows size={15} />
                    </button>
                </div>

                <Link to={`/bikes/${bike.id}`} className={`btn btn-sm w-full justify-center ${upcoming ? "btn-white" : "btn-white"}`} data-testid={`bike-view-${bike.id}`}>
                    {upcoming ? "Register interest" : "View details & quote"}
                </Link>
            </div>
        </div>
    );
};

export default BikeCard;
